import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { Col } from "react-bootstrap";
import Utils from "../../../lib/utils";

import {
  Container,
  Button,
  AppliedBadge,
  StyledCol,
  JobTitle,
  JobDetail,
  JobDetails,
} from "./style.ts";

const JobRow = ({ job, applied }) => {
  const address = () => {
    const cityState = job.city && `${job.city}, ${job.state}`;
    return cityState || job.state;
  };

  const teaser = (message) => {
    const teaserMessage = message && Utils.stripHtmlForTeaser(message);
    const maxLength = 120;
    const trimmedString = teaserMessage && teaserMessage.substr(0, maxLength);
    return (
      trimmedString &&
      trimmedString.substr(
        0,
        Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))
      )
    );
  };

  return (
    <Container>
      <StyledCol xs={10} md={10} style={{ paddingLeft: 0 }}>
        <>
          <JobTitle>
            <Link to={`/jobs/${job.slug}`}>{job.title}</Link>
            {applied.includes(job.id) && <AppliedBadge>Applied</AppliedBadge>}
          </JobTitle>
          <p>
            <span>{teaser(job.description)}...</span>
          </p>
          <div className="info">
            <JobDetails>
              <JobDetail>
                <i className="fa fa-building" /> {job.company_name}
              </JobDetail>
              <JobDetail>
                <i className="fa fa-location-arrow" /> {address(job)}
              </JobDetail>
              <JobDetail>
                <i className="fa fa-calendar" />
                {moment(job.created_at).fromNow()}
              </JobDetail>
            </JobDetails>
          </div>
        </>
      </StyledCol>
      <Col md={2} className="hidden-xs" style={{ padding: "20px 0 0 10px" }}>
        <Button to={`/jobs/${job.slug}`} className="pull-right">
          View
        </Button>
      </Col>
    </Container>
  );
};

export default JobRow;
